module.exports = __webpack_public_path__ + "static/media/ups.534a1c6b.png";